<form [formGroup]="formGroup" class="create-ai-assistant-form-view__wrap" xmlns="http://www.w3.org/1999/html">
  <div>
    <div class="mb20" [ngClass]="{'relative': formGroupData?.meta_title}">
      <span class="step-counter"><span *ngIf="!fromLanding">Step {{currentStep + 1 + addStepsCount}}/{{stepsLength + addStepsCount}}</span>
        <div class="meta-title" *ngIf="formGroupData?.meta_title && !!generatedServices && showMetaTitle">
          <span [innerHTML]="formGroupData?.meta_title"></span>
          <img class="ml8" src="assets/images/icons/ai-generate-blue.svg" />
        </div>
      </span>
    </div>
    <p *ngIf="formGroupData?.title.includes('company_name')"
       class="group-title"
    [innerHTML]="formGroupData?.title
            | replaceTextWithBracers : { old: '{company_name}', new: (formGroup.get('company_name')?.value || oldFormData['company_name'] || formGroup.get('restaurant_name')?.value || oldFormData['restaurant_name']) }"></p>

    <p *ngIf="formGroupData?.title.includes('school_name')"
       class="group-title"
    [innerHTML]="formGroupData?.title
            | replaceTextWithBracers : { old: '{school_name}', new: (formGroup.get('school_name')?.value || oldFormData['school_name'] || formGroup.get('restaurant_name')?.value || oldFormData['restaurant_name']) }"></p>
    <div [ngClass]="{'group-test': formGroupData?.inputs && formGroupData?.inputs[0] && !formGroupData?.inputs[0]?.full_width}">
      <ng-container *ngIf="!(createAiAssistantService.isDataLoading | async); else fallbackContent">
      <ng-container *ngFor="let input of formGroupData?.inputs">
        <div class="ds-input-wrap mb9 {{input?.titleDesc}}" [ngClass]="{'full-width': input?.full_width}"
             *ngIf="input?.field_type === 'text' && input?.name !== domainNameKey">
          <span class="ds-input-label">{{input?.label}}<span class="db-title-desc ml3" *ngIf="input?.titleDesc">{{input?.titleDesc}}</span></span>
          <input type="{{input?.input_type === 'integer' ? 'number' : 'text'}}"
                 class="ds-input ds-input-black"
                 [ngClass]="{'error': (formGroup?.get(input?.name)?.touched && formGroup?.get(input?.name).invalid)}"
                 [placeholder]="input?.placeholder" [formControlName]="input?.name">
          <span *ngIf="formGroup?.get(input?.name)?.touched && formGroup?.get(input?.name).invalid" class="ds-input-error-msg"
                [innerHTML]="formGroup?.get(input?.name)?.errors?.required ? 'This field is required.' :
                    formGroup?.get(input?.name)?.errors?.minlength ? 'To get better results input no less than ' + input?.min_character_limit + ' symbols.'
                    : formGroup?.get(input?.name)?.errors?.maxlength ? 'Character limit reached.' : ''"></span>
        </div>

        <div class="ds-input-wrap mb9" [ngClass]="{'full-width': input?.full_width}" *ngIf="input?.field_type === 'textarea'">
          <div class="ds-textarea-label-wrap" [ngClass]="{'with-enhance': input?.with_enhance}">
            <span *ngIf="input?.label" class="ds-input-label" [innerHTML]="input?.label"></span>
    <!--
            <span class="ds-textarea-counter">{{formGroup?.get(input?.name)?.value?.length || 0}}/{{input?.character_limit}}</span>
    -->
            <a class="generate-ai" *ngIf="input?.with_enhance"
               [ngClass]="{'ds-disabled': generateDescriptionLoading || (formGroup?.get(input?.name).invalid)
            || (input?.min_character_limit && (formGroup?.get(input?.name)?.value).trimEnd().length < input?.min_character_limit) }"
               (click)="generateDescription(formGroup?.get(input?.name)?.value, input?.name)">
              <img *ngIf="!generateDescriptionLoading" [src]="(formGroup?.get(input?.name)?.value).trimEnd().length < input?.min_character_limit ?
               'assets/images/icons/ai-generate-grey.svg' : 'assets/images/icons/ai-generate-blue.svg'">
              <db-loading-circular-spinner class="mr8" [color]="'blue'" [size]="'xs'" *ngIf="generateDescriptionLoading"></db-loading-circular-spinner>
              <span>{{generateDescriptionLoading ? 'Generating...' : 'Enhance with AI'}}</span>
            </a>
          </div>
          <textarea class="ds-textarea ds-textarea-black big no-resize" rows="4" height="100px"
                    [ngClass]="{'error': (formGroup?.get(input?.name)?.touched && formGroup?.get(input?.name).invalid) || !!serverErrors
                    || (formGroup?.get(input?.name)?.touched && input?.min_character_limit && (formGroup?.get(input?.name)?.value).trimEnd().length < input?.min_character_limit)}"
                    [placeholder]="input?.placeholder"
                    [formControlName]="input?.name"></textarea>
          <span *ngIf="(formGroup?.get(input?.name)?.touched && formGroup?.get(input?.name).invalid) || !!serverErrors
                       || (formGroup?.get(input?.name)?.touched && input?.min_character_limit && (formGroup?.get(input?.name)?.value).trimEnd().length < input?.min_character_limit)"
                class="ds-input-error-msg"
                [innerHTML]="!!serverErrors ? serverErrors?.massage : (formGroup?.get(input?.name)?.errors?.minlength || ((formGroup?.get(input?.name)?.value).trimEnd().length < input?.min_character_limit) ? 'To get better results input no less than ' + input?.min_character_limit + ' symbols.'
                    : (formGroup?.get(input?.name)?.errors?.required ? 'This field is required.' : (formGroup?.get(input?.name)?.touched && formGroup?.get(input?.name).invalid ? 'Character limit reached.' : '')))"></span>
        </div>

        <ds-dropdown class="ds-input-wrap mb9"
          *ngIf="input?.field_type === 'dropdown'"
          [value]="formGroup.get(input?.name)?.value"
          [imgPath]="'assets/images/ai/languages/lang-'"
          [dsDropdownLabel]="input?.label"
          [dsDropdownOptions]="input?.options"
          [dsDropdownPlaceHolder]="input?.placeholder || input?.label"
          [dsDropdownWithArrowIcon]="false"
          [smallSize]="true"
          (onOptionChoose)="formGroup.get(input?.name).setValue($event)"
        ></ds-dropdown>

        <ds-dropdown class="ds-input-wrap mb9 custom-dropdown"
          *ngIf="input?.field_type === 'dropdown_lang'"
          [customDropdown]="true"
          [value]="formGroup.get(input?.name)?.value"
          [imgPath]="'assets/images/ai/languages/lang-'"
          [dsDropdownLabel]="input?.label"
          [dsDropdownOptions]="input?.options"
          [dsDropdownPlaceHolder]="input?.placeholder || input?.label"
          [dsDropdownWithArrowIcon]="false"
          [smallSize]="true"
          [dsDropdownListWidth]="238"
          (onOptionChoose)="formGroup.get(input?.name).setValue($event)"
        ></ds-dropdown>


        <div *ngIf="input?.field_type === 'radio'" class="radio-wrap">
          <span *ngIf="input?.label" class="ds-radio-label mb30">{{input?.label}}</span>
          <ng-container *ngFor="let option of input?.options; let i = index">
            <div class="create-ai-assistant-form-view__wrap-options {{input | json}}" [ngClass]="{'selected': input?.default === option?.value}">
              <input class="ds-radio-black"
                     (click)="input?.default && (input.default = option?.value)"
                     [ngClass]="{'ds-radio-disabled': recreationProcess || recreationFinished }"
                     [checked]="input?.default === option?.value"
                     type="radio" [id]="i" [value]="option?.value" [formControlName]="input?.name">
              <label [for]="i">{{option?.label}}</label>
            </div>
          </ng-container>
        </div>

        <div *ngIf="input?.field_type === 'text' && input?.name === domainNameKey && !hasFilledDomainName">
          <div class="db-onboarding__domain">
            <div class="db-onboarding__domain-title">
              <p>Do you own a domain for your website?</p>
            </div>
            <div class="db-onboarding__domain-options">
              <p [ngClass]="{'selected': showDomainInput === 'yes'}"
                 (click)="domainShow('yes')">Yes
              </p>
              <p [ngClass]="{'selected': showDomainInput === 'no'}"
                 (click)="domainShow('no')">No
              </p>
            </div>
          </div>

          <div class="mt10" *ngIf="showDomainInput === 'no'">
            <input type="text" class="ds-input"
                   [placeholder]="input?.placeholder"
                   [formControlName]="input?.name">
          </div>
        </div>

        <!--<div *ngIf="input?.message?.type" class="ds-notification-wrap ds-notification-{{input?.message.type}}">
          <div>
            <i class="db-icon db-icon-ds-info-bg"></i>
            <div>
              <p [innerHTML]="input?.message.title"></p>
              <p *ngIf="input?.message.desc">Example: <span [innerHTML]="input?.message.desc"></span></p>
            </div>
          </div>
        </div>-->
      </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="create-ai-assistant-form-view__action-wrap"
       [ngClass]="{'mt30': formGroupData?.inputs && formGroupData?.inputs[0] && !!formGroupData?.inputs[0]?.full_width,
       'finalize': currentStep + 1 === stepsLength}">
    <div *ngIf="showHigDemandNotice" class="ds-notification-wrap ds-notification-info mt30 mb30">
      <div>
        <i class="db-icon db-icon-ds-info-bg"></i>
        <div>
          <p class="mb15" [innerHTML]="'Due to high demand your website creation is in queue. Please keep this tab open, we\'ll have your site ready shortly. Thanks for your patience!'"></p>
        </div>
      </div>
    </div>
    <div class="buttons-wrap" [ngClass]="{'end': !!recreationFinished, 'column': recreationProcess && isMobile}">
      <div class="db-navigation-text {{createAiAssistantService.hideOnboardingBackButton|async}}" *ngIf="!recreationProcess && !recreationFinished">
        <span *ngIf="!recreationProcess && !recreationFinished && !(createAiAssistantService.hideOnboardingBackButton|async)" class="back-to-previous pr8" (click)="backToPreviousStep()">Back</span>
        <span *ngIf="formGroupData?.canSkip && !recreationProcess" class="skip pl8"
              (click)="proceedToNextQuestion()" [innerHTML]="isMobile ? 'Skip' : 'Skip to the next step'"></span>
      </div>
      <button class="ds-btn-{{currentStep + 1 === stepsLength ? 'purple-blue' : 'black'}} rectangle" *ngIf="!recreationFinished"
              [ngClass]="{'ds-btn-disabled': (showDomainInput === '' && formGroup?.get('domain_name')) || showLoading || recreationProcess || formGroup?.invalid || loading || !!serverErrors}"
              (click)="proceedToNextQuestion(currentStep === stepsLength)">
        <span *ngIf="!showLoading && ((!recreationProcess && !loading) || (currentStep === stepsLength))"><img *ngIf="currentStep + 1 === stepsLength" class="mr4" src="assets/images/icons/ai-generate-white.svg" />{{currentStep + 1 === stepsLength ? 'Generate' : 'Next'}}</span>
        <db-loading-circular-spinner *ngIf="showLoading || ((recreationProcess || loading) && currentStep !== stepsLength)"></db-loading-circular-spinner>
      </button>
    </div>
  </div>

  <div *ngIf="signUpWithHubspot && currentStep + 1 === stepsLength" class="auth-sign-up__have-account">
    <p class="mt0">By signing up, you agree to 10Web’s <a href="https://10web.io/terms-of-service" target="_blank" rel="noopener" class="ds-link">Terms of Service</a> and <a class="sign-up confirm-terms ds-link" href="https://10web.io/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</p>
  </div>
</form>
<div class="create-ai-image-wrap">
  <div class="create-ai-image-1">
      <img src="assets/images/ai/onboarding/ai-{{!!isEcommerce ? 'store' : 'informative'}}-dark.svg" alt="">
  </div>
  <div class="create-ai-image-2">
      <img src="assets/images/ai/onboarding/ai-{{!!isEcommerce ? 'store' : 'informative'}}-dark-full.svg" alt="">
  </div>
</div>


<ng-template #fallbackContent>
  <div class="fallback-form">
    <div class="ds-input-wrap mb9">
      <span class="ds-input-label">Enter company name</span>
      <span class="ds-fake-input ds-lazy-load"></span>
    </div>
    <div class="ds-input-wrap mb9">
      <span class="ds-input-label">Describe your company</span>
      <span class="ds-fake-textarea ds-lazy-load"></span>
    </div>

    <span class="ds-fake-input mt30 m ds-lazy-load"></span>
  </div>

</ng-template>
